<div
  class="team-members-card"
  *mojoHasPrivilege="viewPrivilege"
>
  <mat-progress-bar
    mode="indeterminate"
    *ngIf="loading"
  ></mat-progress-bar>
  <mojo-collection>
    <mat-accordion class="expantion-transition">
      <mat-expansion-panel
        class="mat-expantion-tpanel"
        [expanded]="true"
        (opened)="isPanelOpen = true"
        (closed)="isPanelOpen = false"
      >
        <mat-expansion-panel-header class="team-members ">
          <mojo-collection-header
            text="Team members"
            class="expandible-padding"
            [ngClass]="{'line-margin': isTalentPoolConfig && isExpandible, 'margin-b': isPanelOpen}"
          >
            <div next-to-title>
              <div
                *ngIf="isExpandible"
                class="expand-button"
                color="light-natural"
              >
                <mat-icon
                  *ngIf="!isPanelOpen"
                  class="rotate-arrow color-arrow-expandable font-s-icon mat-icon-right"
                >
                  arrow_drop_up
                </mat-icon>
                <mat-icon
                  *ngIf="isPanelOpen"
                  class="color-arrow-expandable font-s-icon mat-icon-top"
                >
                  arrow_drop_down
                </mat-icon>
              </div>
            </div>
            <aside *mojoHasPrivilege="editPrivilege">
              <a
                class="btn btn-link"
                *ngIf="!loading && isPanelOpen"
                [routerLink]="['', { outlets: { modal: ['team-members'] } }]"
                (click)="onEdit($event)"
                [skipLocationChange]="true"
              >
                <mat-icon>edit</mat-icon>
              </a>
            </aside>
            <aside *ngIf="!isTalentPoolConfig && isPanelOpen">
              <button
                *mojoHasFeatureExtension="oracleRefreshJob"
                (click)="refreshJob()"
                class="update"
                matTooltip="Update"
                matTooltipPosition="above"
                mat-icon-button
              >
                <mat-icon>update</mat-icon>
              </button>
            </aside>
          </mojo-collection-header>
        </mat-expansion-panel-header>
        <div>
          <div
            *ngIf="!loading"
            class="team-members-list"
          >
            <div
              class="team-members-item"
              *ngFor="let teamMember of teamMembersList"
            >
              <mojo-users-item
                *ngIf="teamMember && teamMember.user"
                [user]="teamMember.user"
                [templateType]="userTemplateTypes.listItem"
              >
              </mojo-users-item>
              <span
                *ngIf="teamMember && teamMember.role"
                class="team-member-role"
              >{{ teamMember.role }}</span>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mojo-collection>

  <div
    *ngIf="loading"
    class="padding-line"
  >
    <div class="line-ln"></div>
  </div>

</div>
